import type { StandardOrder } from '@/types/ShopFront/CheckoutStandards'

// Helper to determine if all shipments have a valid option ID for a given order
export type areAllShipmentsAssignedhandler = (order: StandardOrder) => boolean
export const areAllShipmentsAssigned: areAllShipmentsAssignedhandler = (order) => (
  Array.isArray(order?.shipments)
  && !!order.shipments.length
  && order.shipments.every((i) => !!(i.selectedShippingOption))
)

export default areAllShipmentsAssigned
